<template>
  <div
    class="bottom-menu horizontal-menu"
    :style="{
      'background-color': customization.mainColor,
      color: customization.iconColor,
    }"
  >
    <a
      href="recommendfriend"
      class="menu-item"
      :style="{ 'border-color': borderColor }"
    >
      <span class="menu-icon dbc-icon dbc-icon-users-three"></span>
      <span class="text"
        >Refer
        <span
          class="badge"
          :v-if="referralsCount"
          :style="{
            color: customization.mainColor
          }"
          >{{referralsCount}}</span
        >
      </span>
      <span class="menu-arrow dbc-icon dbc-icon-angle-arrow-down"></span>
    </a>
    <a href="garage" class="menu-item" :style="{ 'border-color': borderColor }">
      <span class="menu-icon dbc-icon dbc-icon-solid_car"></span>
      <span class="text"
        >My Garage
        <span
          class="badge"
          v-if="purchasedVehiclesCount && homePageMenuType.bottomList"
          :style="{
            color: customization.mainColor
          }"
          >{{ purchasedVehiclesCount }}</span
        >
      </span>
      <span class="menu-arrow dbc-icon dbc-icon-angle-arrow-down"></span>
    </a>
    <a
      href="contact"
      class="menu-item"
      :style="{ 'border-color': borderColor }"
    >
      <span class="menu-icon dbc-icon dbc-icon-card-account-phone"></span>
      <span class="text">Contact</span>
      <span class="menu-arrow dbc-icon dbc-icon-angle-arrow-down"></span>
    </a>
    <a
      href="inventory"
      class="menu-item"
      :style="{ 'border-color': borderColor }"
    >
      <span class="menu-icon dbc-icon dbc-icon-map_car-dealer"></span>
      <span class="text">Shop</span>
      <span class="menu-arrow dbc-icon dbc-icon-angle-arrow-down"></span>
    </a>
    <a href="about" class="menu-item" :style="{ 'border-color': borderColor }">
      <span class="menu-icon dbc-icon dbc-icon-businessman"></span>
      <span class="text">About</span>
      <span class="menu-arrow dbc-icon dbc-icon-angle-arrow-down"></span>
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Request } from '../../shared/base.requests'
import config from '../../../config/customer.api'
import colorHelper from '../../helpers/color.helper'
import { homePageMenuType } from '../../shared/enums/menu.type'
import { downloadVCF } from '../../helpers/vcf.helper'

export default {
  name: 'horizontal-menu',
  props: {
    referralsCount: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    ...mapState({
      customization: (state) => state.common.customization,
      customButtons: (state) => state.common.customButtons,
      purchasedVehiclesCount: (state) => state.common.purchasedVehiclesCount,
      pageEnum: (state) => state.about.pagesEnum,
      SharepageEnum: (state) => state.recommendFriend.pageEnum,
      salesId: (state) => state.common.salesCustomerAppId,
      company: (state) => state.aboutCompany.companyData
    }),
    borderColor () {
      return colorHelper.hexToRgb(this.customization.iconColor, 0.2)
    }
  },
  methods: {
    HasInventory () {
      if (this.company != null) {
        return this.company.hasInventory === true
      } else return false
    },
    IsVisible_li (b) {
      if (b.name === 'Shop' && this.HasInventory() === false) {
        return false
      }
      if (b.name === 'Videos' && this.videoMessageCount === 0) {
        return false
      }
      if (
        b.name === 'Map' &&
        this.company != null &&
        this.company.adress == null
      ) {
        return false
      }
      return true
    },
    OnItemClick (b, event) {
      if (this.isClickFired) {
        if (!this.isTouch) {
          if (b.hasActivity && b.name != null) {
            this.LogActivity(b.name)
          }
          if (b.name === 'Social') {
            this.setPage(this.pageEnum.Socials)
          }
          if (b.name === 'About') {
            this.setPage(this.pageEnum.Media)
          }
          if (b.name === 'Call' || b.name === 'Email' || b.name === 'Text') {
            this.redirectW(b.url)
          }
          if (b.name !== null && b.name.startsWith('Share')) {
            this.setPageShare(this.SharepageEnum.share)
          }
          if (b.name === 'VCard') {
            this.LoadVCard()
            return
          }
          if (b.url) {
            if (!b.url.startsWith('http')) {
              this.$f7.mainView.router.load({ url: b.url })
            } else {
              console.log('custom url')
              window.open(b.url, '_blank')
            }
          }
        }
      }
    },
    OnTouchStart (event) {
      console.log(event)
      this.touchEventStartHandler = event
      this.isClickFired = false
    },
    LoadVCard () {
      var url = config.downloadVCF + '/' + this.salesId
      downloadVCF(url, this.$store.state.standalone.isStandalone)
    },
    setPage (args) {
      this.$store.dispatch('about/setPageAbout', args)
    },
    setPageShare (args) {
      this.$store.dispatch('recommendFriend/setPage', args)
    },
    redirectToSiteUrl (Url) {
      this.$router.load({ url: Url })
    },
    LogActivity (type) {
      if (type != null) {
        Request.get(config.logCustomerActivity + type)
      }
    },
    redirectW (url) {
      if (url) {
        console.log(url)
        document.location.href = url
      }
    }
  },
  data () {
    return {
      isTouch: false,
      touchEventStartHandler: undefined,
      touchEventEndHandler: undefined,
      isClickFired: true,
      homePageMenuType
    }
  }
}
</script>

<style scoped>
.bottom-menu {
  display: none;
}

.bottom-menu.horizontal-menu,
.bottom-menu.list-menu {
  z-index: 1;
  width: 100%;
  display: flex;
  box-sizing: border-box;
}

.menu-item,
.menu-item:active,
.menu-item:focus {
  color: inherit;
}

.menu-item:hover {
  cursor: pointer;
}

.menu-icon,
.menu-arrow {
  color: inherit;
  margin: 0;
  padding: 0;
  font-size: 24px;
}

.horizontal-menu .text {
  font-size: 0.7em;
}

.horizontal-menu {
  align-items: center;
  justify-content: center;
}

.horizontal-menu .menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 10px 0;
  position: relative;
}

.horizontal-menu .menu-item .badge{
   position: absolute;
    top: 2px;
    left: 50%;
}

.horizontal-menu .menu-arrow {
  display: none;
}

.list-menu {
  flex-direction: column;
}

.list-menu .menu-item {
  border-bottom: 1px solid;
  padding: 15px 20px;
  display: flex;
  align-items: center;
}

.list-menu .menu-item .menu-icon {
  margin-right: 15px;
}

.list-menu .menu-item .menu-arrow {
  margin-left: auto;
  font-size: 1rem;
  opacity: 0.5;
}

.list-menu .menu-item .text{
  display: inline-flex;
  align-items: center;
}

.badge {
  display: inline-block;
  height: 20px;
  min-width: 20px;
  text-align: center;
  border-radius: 10px;
  padding: 0px 7px;
  line-height: 19px;
  margin-left: 5px;
  font-weight: 600;
  font-size: 0.8rem;
  background-color: rgb(255, 61, 61);
}

</style>



// WEBPACK FOOTER //
// bottom-panel-menu.component.vue?4641df89